import { gql } from "@apollo/client";

export const CREATE_BOOK_CONTENT = gql`
  mutation CreateBookContent($input: BookContentInput) {
    createBookContent(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_BOOK_CONTENT_PAGINATION = gql`
  query GetBookContentPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $bookId: String
  ) {
    getBookContentPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      bookId: $bookId
    ) {
      data {
        _id
        title
        bookId {
          _id
          groupFeeId {
            _id
            type
            title
            price
            remark
          }
          numbering
          description
          author
          type
          rating
          pages
          image
        }
        pageNumber
        description
        file
        fileType
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_BOOK_CONTENT = gql`
  mutation UpdateBookContent($id: ID!, $input: BookContentInput) {
    updateBookContent(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_BOOK_CONTENT = gql`
  mutation DeleteBookContent($id: ID!) {
    deleteBookContent(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
